module.exports = __webpack_public_path__ + "static/media/img7.fc023725.jpg";